import { RouteObject } from "react-router-dom";
import { AllTokens } from "gql/graphql";
import { Guard } from "@/shared/security/model/guard/guard";
import {
  DISK_SPACE_PATH,
  DiskSpacePage,
} from "@/modules/file-storage/pages/disc-space";

export const fileStorage: RouteObject[] = [
  {
    path: DISK_SPACE_PATH,
    element: (
      <Guard.Redirect.IfCantModify.PageNotFound
        influencedBy={[AllTokens.AdminStorageInfo]}
      >
        <DiskSpacePage />
      </Guard.Redirect.IfCantModify.PageNotFound>
    ),
  },
];
